<template>
    <div>
        <hd-header></hd-header>
        <div style="padding-top: 130px;padding-bottom: 160px;" :style="{paddLeft:marginLeft+'px'}">
            <div style="text-align: center;">
                <img src="../../assets/images/progress/one.png" alt="">
            </div>
            <!-- <div style="padding-left: 200px;">
            <el-steps :active="1" style="width: 1200px;">
                <el-step title="One">
                </el-step>
                <el-step title="Two"></el-step>
                <el-step title="Three"></el-step>
            </el-steps>
        </div> -->
            <div style="display: flex;justify-content: center;align-items: center;padding-bottom:
                50px;padding-top: 50px;">
                <sub-teacher-agreement next="/teacher-info" style="width: 1000px;">
                </sub-teacher-agreement>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
    import HdHeader from '../public/Header.vue';
    import HdFooter from '../public/FooterLogined.vue';
    import SubTeacherAgreement from '../public/sub/SubTeacherAgreement.vue'

    export default {
        name: 'TeacherAgreement',
        components: {
            HdHeader,
            HdFooter,
            SubTeacherAgreement
        },
        mounted() {
            let that = this;
            this.$nextTick(function() {
                this.marginLeft = (document.body.offsetWidth - 1000) / 2;
            });
        },
        data: function() {
            return {
                marginLeft: 0,
                isAgree: 0
            };
        },
        methods: {
            nextStep: function() {
                if (!this.isAgree) {
                    this.$message.error('请勾选同意');
                    return;
                }
                this.$router.push({
                    path: '/teacher-info'
                });
            }
        }
    }
</script>

<style>
    body {
        background-color: #F8F8F8;
    }

    .div-agreement {
        padding: 15px;
        font-size: 14px;
    }

    .div-agreement p {
        text-indent: 2em;
    }
</style>



// WEBPACK FOOTER //
// src/components/teacher/TeacherAgreement.vue